import { useState } from "react";
import { useEffect } from "react";
import { SafeArea } from "capacitor-plugin-safe-area";

export function useStatusBarHeight() {
  const [statusBarHeight, setStatusBarHeight] = useState(0);
  useEffect(() => {
    SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
      setStatusBarHeight(statusBarHeight);
    });
  }, []);

  return statusBarHeight;
}
